import Auth from '../api/auth';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';

const parseErrorCode = error => Promise.reject(error);

let isForcingLogout = false;

const isAuthEndpoint = url =>
  typeof url === 'string' && /(^|\/)auth\//.test(url);

const isSessionExpired = error => Array.isArray(error?.response?.data?.errors);

const forceLogoutOnUnauthorized = async error => {
  const status = error?.response?.status;
  const requestUrl = error?.config?.url;
  if (
    status === 401 &&
    !isForcingLogout &&
    Auth.hasAuthCookie() &&
    !isAuthEndpoint(requestUrl) &&
    isSessionExpired(error)
  ) {
    isForcingLogout = true;
    try {
      await deleteIndexedDBOnLogout();
    } finally {
      clearCookiesOnLogout();
    }
  }
  return parseErrorCode(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => forceLogoutOnUnauthorized(error)
  );
  return wootApi;
};
